import { GraphqlApi } from 'services/api';
import { jwtDecode } from 'jwt-decode';
import { clearAllCookies, setCookie, clearCookie } from "utils/function-utils";
import {
    USER_LOGIN_REQUEST,
    USER_LOGIN_SUCCESS,
    USER_LOGIN_FAIL,
    TOKEN_RENEW_FAIL,
    TOKEN_RENEW_REQUEST,
    TOKEN_RENEW_SUCCESS,
    RECEIVE_ACCESS_TOKEN,
    CLEAR_USER_INFO,
    USERS,
    SET_ALL_USERS,
    SET_ROLE_LIST,
    GET_MODEL_HIERARCHY_SUCCESS,
    GET_MODEL_HIERARCHY_FAIL,
    GET_MODEL_HIERARCHY_REQUEST,
    DELETE_MODEL_HIERARCHY_REQUEST,
    DELETE_MODEL_HIERARCHY_SUCCESS,
    DELETE_MODEL_HIERARCHY_FAIL,
    UPDATE_MODEL_HIERARCHY_SUCCESS,
    UPDATE_MODEL_HIERARCHY_REQUEST,
    UPDATE_MODEL_HIERARCHY_FAIL,
    CREATE_MODEL_HIERARCHY_REQUEST,
    CREATE_MODEL_HIERARCHY_SUCCESS,
    CREATE_MODEL_HIERARCHY_FAIL,
    FILTER_MODELHRCY,
    CLEAR_MODELHRCY_FILTERS,
    GET_OC_UI_SPEC_REQUEST,
    GET_OC_UI_SPEC_SUCCESS,
    GET_OC_UI_SPEC_FAIL,
    FILTER_OC_UI_SPEC,
    CLEAR_OC_UI_SPEC_FILTERS,
    CREATE_OC_UI_SPEC_REQUEST,
    CREATE_OC_UI_SPEC_SUCCESS,
    CREATE_OC_UI_SPEC_FAIL,
    UPDATE_OC_UI_SPEC_REQUEST,
    UPDATE_OC_UI_SPEC_SUCCESS,
    UPDATE_OC_UI_SPEC_FAIL,
} from "constants/userConstants";
import { snackBar } from './modelActions';


export const login = (email, password) => async (dispatch) => {
    dispatch({ type: USER_LOGIN_REQUEST, payload: { email, password } });
    try {
        // TODO: Create fixed data, instead real from axios
        const data = USERS[password === "admin" ? 1 : 0];
        const token = "123"; // void token
        data['userEmail'] = email;
        dispatch({ type: USER_LOGIN_SUCCESS, payload: { data, token } });
        setCookie("userInfo", JSON.stringify(data));
        setCookie("access_token", "123");
    } catch (err) {
        dispatch({ type: USER_LOGIN_FAIL, payload: err.message });
        dispatch(snackBar(true, err.message, 'error'));
    }
};

export const receiveAccessToken = (access_token, expires_at) => async (dispatch) => {
    try {
        let user = jwtDecode(access_token);
        if (access_token && expires_at && expires_at > new Date().getTime() / 1000) {
            setCookie("userInfo", user);
            setCookie("access_token", access_token);
            setCookie("expiresAt", expires_at);
            dispatch({
                type: RECEIVE_ACCESS_TOKEN,
                payload: { user, token: access_token, expires_at }
            });
        } else {
            var expires_time = new Date(expires_at * 1000);
            throw new Error("Token has expired at " + expires_time.toLocaleString());
        }
    } catch (error) {
        dispatch({ type: USER_LOGIN_FAIL, payload: error.message });
        dispatch(snackBar(true, error.message, 'error'));
    }
}

export const resetAccessCookies = () => {
    clearCookie("access_token");
    clearCookie("expiresAt");
    clearCookie("access_token", { path: "/", domain: ".hpicloud.net" });
    clearCookie("expires", { path: "/", domain: ".hpicloud.net" });
    clearCookie("access_token", { path: "/", domain: ".hp.com" });
    clearCookie("expires", { path: "/", domain: ".hp.com" });
};

export const renewToken = () => (dispatch) => {
    dispatch({ type: TOKEN_RENEW_REQUEST });
    GraphqlApi.query('renewToken').then((tokenResponse) => {
        const tokenDetails = tokenResponse.data.renewToken;
        resetAccessCookies();
        setCookie("access_token", tokenDetails.token, {
            path: "/",
            domain: window.location.hostname
        });
        setCookie("expires", tokenDetails.expires_at, {
            path: "/",
            domain: window.location.hostname
        });
        dispatch({ type: TOKEN_RENEW_SUCCESS, payload: tokenDetails.token });
    }).catch(error => {
        dispatch(snackBar(true, error.message));
        dispatch({ type: TOKEN_RENEW_FAIL, payload: error.message });
    })
};


export const logout = () => async (dispatch) => {
    clearAllCookies();
    dispatch({ type: CLEAR_USER_INFO });
};

export const getUsers = () => {
    return async (dispatch) => {
        try {
            const res = await GraphqlApi.query('getUsers');
            const users = res.data.kbUsersWithRoles.users;
            const roles = res.data.kbUsersWithRoles.roles;
            dispatch(setAllUsers(users));
            dispatch(setRoleList(roles));
        } catch (error) {
            dispatch(snackBar(true, error.message));
        }
    };
};

export const setAllUsers = (users) => ({ type: SET_ALL_USERS, payload: users });

export const setRoleList = (roles) => ({ type: SET_ROLE_LIST, payload: roles });

export const updateUser = (firstNameUpdation, lastNameUpdation, chosenUser, selectedValue) => {
    return async (dispatch) => {
        try {
            await GraphqlApi.query("updateKbUser", {
                model: {
                    firstName: firstNameUpdation,
                    lastName: lastNameUpdation,
                    email: chosenUser.email,
                    role: chosenUser?.role || '',
                    ocplcRole: chosenUser?.ocplcRole || '',
                    roles: selectedValue
                }
            });
            dispatch(snackBar(true, "User updated successfully", "success"))
            dispatch(getUsers());
        } catch (error) {
            dispatch(snackBar(true, error.message, "error"));
        }
    };
};

export const deleteUser = (chosenUser) => {
    return async (dispatch) => {
        try {
            await GraphqlApi.query("deleteKbUser", { email: chosenUser.email });
            dispatch(snackBar(true, "User deleted successfully", "success"))
            dispatch(getUsers());
        } catch (error) {
            dispatch(snackBar(true, error.message, "error"));
        }
    };
};

export const createUser = (firstName, lastName, email, selectedValue) => {
    return async (dispatch) => {
        try {
            await GraphqlApi.query("createKbUser", {
                model: {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    role: '',
                    ocplcRole: '',
                    roles: selectedValue
                }
            });
            dispatch(snackBar(true, "User created successfully", "success"))
            dispatch(getUsers());
        } catch (error) {
            dispatch(snackBar(true, error.message, "error"));
        }
    };
};

export const getModelHierarchy = ( filter = { category: "", series: "" } ) => async (dispatch) => {
    dispatch({ type: GET_MODEL_HIERARCHY_REQUEST });
    try {
        const res = await GraphqlApi.query("getModelHierarchy", { filter });
        const modelHierarchy = res.data.getModelHrchyDetails;
        dispatch({ type: GET_MODEL_HIERARCHY_SUCCESS, payload: modelHierarchy });
        return modelHierarchy;
    } catch (error) {
        dispatch({ type: GET_MODEL_HIERARCHY_FAIL, payload: error.message });
        dispatch(snackBar(true, error.message, "error"));
        return null;
    }
};


export const deleteModelHierarchy = (kmat_id, region, email) => async (dispatch) => {
    dispatch({ type: DELETE_MODEL_HIERARCHY_REQUEST });
        try {
            const res = await GraphqlApi.query("updateModelHierarchy", { input: { kmat_id, region, email, action: "Delete" } });
            const responseData=res?.data?.ModelHierarchy
            const message = responseData?.Message;
            if(responseData?.Status === "Success"){
                dispatch({ type: DELETE_MODEL_HIERARCHY_SUCCESS, payload: responseData });
                dispatch(getModelHierarchy());
                dispatch(snackBar(true, message, "success"));
            }
        } catch (error) {
            dispatch({ type: DELETE_MODEL_HIERARCHY_FAIL, payload: error.message });
            dispatch(snackBar(true, error.message, "error"));
        }
    };
  
 export const updateModelHierarchy = (kmat_id, region, series, model_name, sub_category, email) => async (dispatch) => {
     dispatch({ type: UPDATE_MODEL_HIERARCHY_REQUEST });
     try {
         const res = await GraphqlApi.query("updateModelHierarchy", { input: { kmat_id, region, series, model_name, sub_category, email, action: "Edit" } });
         const responseData = res?.data?.ModelHierarchy
         const message = responseData?.Message;
         if (responseData?.Status === "Success") {
             dispatch({
                 type: UPDATE_MODEL_HIERARCHY_SUCCESS,
                 payload: {
                     kmat_id: responseData.kmat_id,
                     region: responseData.region,
                     model_name: responseData.model_name,
                     category: responseData.category,
                     series: responseData.series,
                     sub_category: responseData.sub_category,
                     last_modified_by: responseData.last_modified_by,
                     last_modified_ts: responseData.last_modified_ts
                 }
             });
             dispatch(getModelHierarchy());
             dispatch(snackBar(true, message, "success"));
         }
     } catch (error) {
        dispatch({ type: UPDATE_MODEL_HIERARCHY_FAIL, payload: error.message });
        dispatch(snackBar(true, error.message, "error"));
    } 
};

export const createModelHierarchy = (kmat_id, region, category, series, model_name, sub_category, email) => async (dispatch) => {
    dispatch({ type: CREATE_MODEL_HIERARCHY_REQUEST });
    try {
        const res = await GraphqlApi.query("updateModelHierarchy", { input: { kmat_id, region, category, series, model_name, sub_category, email, action: "Submit" } });
        const responseData=res?.data?.ModelHierarchy
        const message = responseData?.Message;
        if (responseData?.Status === "Success") {
            dispatch({
                type: CREATE_MODEL_HIERARCHY_SUCCESS,
                payload: {
                    kmat_id: responseData.kmat_id,
                    region: responseData.region,
                    model_name: responseData.model_name,
                    category: responseData.category,
                    series: responseData.series,
                    sub_category: responseData.sub_category,
                    last_modified_by: responseData.last_modified_by,
                    last_modified_ts: responseData.last_modified_ts
                }
            });
            dispatch(snackBar(true, message, "success"));
        }
    } catch (error) {
        dispatch({ type: CREATE_MODEL_HIERARCHY_FAIL, payload: error.message });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const filterModelHrcy = (payload) => (dispatch) => {
    dispatch({ type: FILTER_MODELHRCY, payload })
}

export const clearModelHrcyFilters = () => (dispatch) => {
    dispatch({ type: CLEAR_MODELHRCY_FILTERS })
}

export const getOcUiSpec = () => async (dispatch) => {
    dispatch({ type: GET_OC_UI_SPEC_REQUEST });
    try {
        const res = await GraphqlApi.query("fetchUIspecChoice");
        const ocUiSpecResponse = res?.data?.fetchUIspecChoice?.uispec || [];
        dispatch({ type: GET_OC_UI_SPEC_SUCCESS, payload: ocUiSpecResponse });
    } catch (error) {
        dispatch({ type: GET_OC_UI_SPEC_FAIL, payload: error.message });
        dispatch(snackBar(true, error.message, "error"));
    }
};
   
export const filterOcUiSpec = (payload) => (dispatch) => {
    dispatch({ type: FILTER_OC_UI_SPEC, payload });
};

export const clearOcUiSpecFilters = () => (dispatch) => {
    dispatch({ type: CLEAR_OC_UI_SPEC_FILTERS });
};


export const createSubSectionOrChoice = (input, isSubSection) => async (dispatch) => { 
    dispatch({ type: CREATE_OC_UI_SPEC_REQUEST });
    try {
        const queryName = isSubSection ? "CreateNewSubSection" : "CreateNewChoice";
        const res = await GraphqlApi.query(queryName, { input });
        const responseData = isSubSection ? res?.data?.createUIspecSubSection : res?.data?.createUIspecChoice;
        const message = responseData?.message;
        if (responseData?.status === "Success") {
            dispatch({ type: CREATE_OC_UI_SPEC_SUCCESS, payload: responseData.data });
            dispatch(getOcUiSpec());
            dispatch(snackBar(true, message, "success"));
        } else {
            const errorMessage = message || 'Failed to create sub-section or choice';
            dispatch({ type: CREATE_OC_UI_SPEC_FAIL, payload: errorMessage });
            dispatch(snackBar(true, errorMessage, "error"));
        }
    } catch (error) {
        dispatch({ type: CREATE_OC_UI_SPEC_FAIL, payload: error.message });
        dispatch(snackBar(true, error.message, "error"));
    }
};

export const editUiSpec = (input) => async (dispatch) => {
    dispatch({ type: UPDATE_OC_UI_SPEC_REQUEST });
    try {
        const res = await GraphqlApi.query( "updateOcUiSpec", { input });
        const responseData = res?.data?.updateUIspec;
        const message = responseData?.message;
        if (responseData?.status === "Success") {
            dispatch({ type: UPDATE_OC_UI_SPEC_SUCCESS, payload: responseData.data });
            dispatch(getOcUiSpec());
            dispatch(snackBar(true, message, "success"));
        } else {
            const errorMessage = message || 'Failed to update the choice';
            dispatch({ type: UPDATE_OC_UI_SPEC_FAIL, payload: errorMessage });
            dispatch(snackBar(true, errorMessage, "error"));
        }
    } catch (error) {
        dispatch({ type: UPDATE_OC_UI_SPEC_FAIL, payload: error.message });
        dispatch(snackBar(true, error.message, "error"));
    }
};

